import { render, staticRenderFns } from "./IdleWidgetTouch.vue?vue&type=template&id=335b6686&scoped=true&"
import script from "./IdleWidgetTouch.vue?vue&type=script&lang=js&"
export * from "./IdleWidgetTouch.vue?vue&type=script&lang=js&"
import style0 from "./IdleWidgetTouch.vue?vue&type=style&index=0&id=335b6686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335b6686",
  null
  
)

export default component.exports